//import _ from 'underscore';
import _ from 'lodash';
import moment from 'moment';
import templateStr from 'text!./full-per-capita.html';
import 'portalConfig';
import DateUtil from 'gw-portals-util-js/DateUtil';

export default (function () {
	return {
		restrict: 'A',
		template: templateStr,
		transclude: true,
		scope: {
			hideForm: '&',
			type: '=',
			jobNumber: '=',
			policy: '=',
			edit: '=',
			perCapitaClassFixedId: '=',
			sharedClass: '=',
			auditPayrollResults: '=',
			fullTimeLength: '=',
			fullPerCapitaRecords: '=',
			fullTimeRecordReady: '='

		},

		controller: ['$scope', '$rootScope', 'policy.PolicyService', 'ModalService', 'ViewModelService', '$state', '$filter', 'CancellationService', '$stateParams', function ($scope, $rootScope, PolicyService, ModalService, ViewModelService, $state, $filter, CancellationService, $stateParams) {

			$scope.count = 0;
			$scope.employeeList = [];
			setTimeout(function () {}, 6000);
			var actualDate = new Date($stateParams.startDate);
			var actualEndDate = new Date($stateParams.endDate);

			$scope.policyEffDate = $stateParams.startDate;
			$scope.policyExpDate = $stateParams.endDate;

			var validNumber = new RegExp(/^[0-9]+([,.][0-9]+)?$/);
			var updateStart = {
				year: actualDate.getFullYear(),
				month: actualDate.getMonth(),
				day: actualDate.getDate()
			};
			$scope.startDate = updateStart;
			var updateEnd = {
				year: actualEndDate.getFullYear(),
				month: actualEndDate.getMonth(),
				day: actualEndDate.getDate()
			};

			var updateEndStart = {
				year: actualDate.getFullYear(),
				month: actualDate.getMonth(),
				day: actualDate.getDate() - 1
			};
			$scope.endStartDate = updateEndStart;
			var limitEnd = {
				year: actualEndDate.getFullYear(),
				month: actualEndDate.getMonth(),
				day: actualEndDate.getDate() - 1
			};
			var limitStart = {
				year: actualDate.getFullYear(),
				month: actualDate.getMonth(),
				day: actualDate.getDate() - 1
			};
			$scope.limitStart = limitStart;

			$scope.endDate = updateEnd;

			$scope.limitEnd = limitEnd;
			$scope.employeeInValid = true;

			$scope.tot_percapita_amount = 0;
			/**
   * Function to retrieve perCapita Total from Reports.
   * @param{Object} -emp
   * @returns{Decimal} - total_perCapita_amt variable set
   & @private
   **/
			$scope.getCapitaTotal = function (emp) {

				$scope.tot_percapita_amount = null;
				angular.forEach($scope.employeeList, function (result) {
					if (result.reportedPerCapita !== undefined && result.reportedPerCapita !== '' && result.reportedPerCapita != null || result.reportedPerCapita === 0) {
						if ($scope.tot_percapita_amount == null) {
							$scope.tot_percapita_amount = parseFloat(result.reportedPerCapita);
						} else {
							$scope.tot_percapita_amount = $scope.tot_percapita_amount + parseFloat(result.reportedPerCapita);
						}
					}
				});
			};

			/**
    * Function to add per capita row
    * @params{void}
    * @returns{void}
    * @private
    **/
			$scope.addRow = function () {

				var rowData = {};

				$scope.count = $scope.count + 1;
				rowData.name = "";
				if (rowData.name == '' || rowData.name == undefined) {
					$scope.employeeInValid = true;
				} else {
					$scope.employeeInValid = false;
				}
				if ($scope.startDate.year) {
					var start = new Date($scope.startDate.year, $scope.startDate.month, $scope.startDate.day);
					rowData.startDate = moment(start).format("MM/DD/YYYY");
				} else {
					rowData.startDate = moment($scope.startDate).format("MM/DD/YYYY");
				}

				if ($scope.endDate.year) {

					var end = new Date($scope.endDate.year, $scope.endDate.month, $scope.endDate.day);
					rowData.endDate = moment(end).format("MM/DD/YYYY");
				} else {

					rowData.endDate = moment($scope.endDate).format("MM/DD/YYYY");
				}
				rowData.id = $scope.count;
				/**
    * function to retrieve part time number of days
    * @params{string, String, String} - jobNumber, startDate, endDate
    * @returns{Object} - response returns - noOfDays, reportedPerCapitaVal
    * @private
    **/
				PolicyService.getPartTimeNumberOfDays($stateParams.jobNumber, $stateParams.startDate, $stateParams.endDate).then(function (res) {

					rowData.days = res.noOfDays;
					rowData.reportedPerCapita = res.reportedPerCapitaVal;

					$scope.employeeList.push(rowData);
					$scope.getCapitaTotal(rowData);
				});
			};

			/**
   * Function to check related record
   * @params{Object} - employee
   * @returns{boolean}
   * @private
   **/
			$scope.relatedRecord = function (employee) {

				if (!employee.fixedId) return true;
				if (employee.fixedId == $scope.perCapitaClassFixedId) {

					return true;
				}
				return false;
			};

			/**
   * Function to validate Per Capita Row level data
   * @params{Object} - employee
   * @returns{boolean}
   * @private
   **/
			$scope.validateRow = function (emp) {

				if (emp.name == "") {
					return false;
				}
				if (emp.reportedPerCapita == "") {
					return false;
				}
				//check start date and end date is empty or not
				if (emp.startDate == null || emp.endDate == null) {
					return false;
				} else {
					return true;
				}
				//check reported per capita error
				if (emp.reportedPerCapita != "" && emp.reportedPerCapita != undefined) {
					if (emp.reportedPerCapita !== '' || emp.reportedPerCapita !== null) {
						if (validNumber.test(emp.reportedPerCapita) === false) {
							return false;
						}
					}
				} else {
					return false;
				}
				return true;
			};
			/**
   * Function to Monitor changeChanged Event
   * @params{Object, Object} - data, val
   * @returns{void}
   * @private
   **/
			//Change diff days when change in datepicker
			$scope.$on('dateChanged', function (data, val) {
				$scope.tempList = [];
				var id = 'Hours' + val.id;
				setTimeout(function () {
					angular.element('#' + id).trigger('click');
				}, 100);
			});

			//get full time per capita
			$scope.allPerCapitaRecords = [];
			var alltypes = ['Employees', 'Family Member', 'Owner Officer'];
			var allTypesLength = alltypes.length;
			angular.forEach(alltypes, function (classType) {
				allTypesLength--;
				if ($scope.auditPayrollResults) {
					angular.forEach($scope.auditPayrollResults.payrollData, function (payroll) {
						if (payroll.fullTime) {
							var resLength = payroll.fullTime.length;
							angular.forEach(payroll.fullTime, function (fullTime) {
								resLength--;
								var actualDate = new Date(fullTime.startDate);
								var actualEndDate = new Date(fullTime.endDate);
								var start = {
									year: actualDate.getFullYear(),
									month: actualDate.getMonth(),
									day: actualDate.getDate()
								};
								var end = {
									year: actualEndDate.getFullYear(),
									month: actualEndDate.getMonth(),
									day: actualEndDate.getDate()
								};
								$scope.count = $scope.count + 1;
								var rowData = {};
								rowData.fixedId = fullTime.classFixedId;
								rowData.name = fullTime.name;
								rowData.startDate = start;

								rowData.endDate = end;
								rowData.id = $scope.count;
								rowData.days = fullTime.days;
								rowData.reportedPerCapita = fullTime.reportedPerCapita;
								rowData.type = payroll.earningsType;
								$scope.allPerCapitaRecords.push(rowData);

								if (allTypesLength == 0 && resLength == 0) {
									//pass to parent controller
									$scope.$emit('fullTimePerCapitaEmployees', $scope.allPerCapitaRecords);
								}
							});
						}
					});
				}
			});

			/**
   * Function for updating templist
   * @params {object,object}
   * @returns {Object} - updates $scope.templist and adds valid item to existing tempList.
   * @private
   **/
			$scope.updateTempList = function (res, emp) {
				var valid = $scope.validateRow(res);
				if (valid == false) {
					$scope.employeeInValid = true;
				}
				if (res.id == emp.id) {
					$scope.tempList.push(emp);
				} else {
					$scope.tempList.push(res);
				}
			};

			//Save row Data
			/**
         * Function executed on Save
         * @params {Object, String} - emp, type
         * @returns {Object} - updates $scope.templist and adds valid item to existing tempList.
         * @private
         **/
			$scope.onSave = function (emp, type) {

				if ($scope.employeeList) {
					angular.forEach($scope.employeeList, function (empList) {
						if (empList.name == '' || empList.name == undefined || empList.startDate == null || empList.endDate == null) {
							$scope.employeeInValid = true;
						} else {
							$scope.employeeInValid = false;
						}
					});
				}

				var start = new Date(emp.startDate.year, emp.startDate.month, emp.startDate.day);
				var end = new Date(emp.endDate.year, emp.endDate.month, emp.endDate.day);
				var termEffectiveDate = new Date($scope.startDate.year, $scope.startDate.month, $scope.startDate.day);

				$scope.startDateVal = new Date(emp.startDate).toISOString();
				$scope.endDateVal = new Date(emp.endDate).toISOString();
				var termEffectiveDateString = new Date(termEffectiveDate).toISOString();

				$scope.invalidStartDate = false;
				$scope.invalidEndDate = false;

				/**
    * Function to Validate start date and end date to display validation message
    * @params {String, String, String} - jobNumber, startDate, endDate
    * @returns {Object} - updates $scope.templist and adds valid item to existing tempList.
    * @private
    **/
				PolicyService.validateStartDate($scope.policy, $scope.startDateVal, termEffectiveDateString).then(function (startRes) {

					PolicyService.validateEndDate($scope.policy, $scope.startDateVal, $scope.endDateVal, termEffectiveDateString).then(function (endRes) {

						if (startRes == true) $scope.invalidStartDate = true;
						if (endRes == true) $scope.invalidEndDate = true;
						if (startRes == true && endRes == true) {
							$scope.invalidStartDate = true;
							$scope.invalidEndDate = true;
						}
						if (startRes != true && endRes != true) {
							if (type == 'startDate') {
								PolicyService.updateDaysAndRepPerCapita($stateParams.jobNumber, $scope.startDateVal, $scope.endDateVal).then(function (res) {

									$scope.diffDays = res.noOfDays;
									if (res.noOfDays < 0) {
										emp.days = 0;
										emp.reportedPerCapita = 0;
									} else {
										if (res.noOfDays == null || res.reportedPerCapitaVal == null) {
											emp.days = 0;
											emp.reportedPerCapita = 0;
										} else {
											emp.days = res.noOfDays;
											emp.reportedPerCapita = res.reportedPerCapitaVal;
										}
										$scope.getCapitaTotOnChange(emp);
									}
								});
							}
							if (type == 'endDate') {
								/**
        * Function to update EndDate and PerCapita information.
        * @params{String, String, String} - jobNumber, startDate, endDate
        * @returns {Object} - updates $scope variables.
        **/
								PolicyService.updateEndDateAndPerCapita($stateParams.jobNumber, $scope.startDateVal, $scope.endDateVal).then(function (res) {

									$scope.diffDays = res.noOfDays;
									if (res.noOfDays < 0) {
										emp.days = 0;
										emp.reportedPerCapita = 0;
									} else {
										emp.days = res.noOfDays;
										emp.reportedPerCapita = res.reportedPerCapitaVal;
										$scope.getCapitaTotOnChange(emp);
									}
								});
							}
						}
					});
				});

				//get no of days and reported per capita value on change of start date and disable submit button
				if (type && type == 'startDate') {
					/**
        * Function to validate Start Date.
        * @params{String, String, String} - jobNumber, startDate, endDate
        * @returns {Object} - updates $scope variables.
        **/
					PolicyService.validateStartDate($scope.policy, $scope.startDateVal, termEffectiveDateString).then(function (result) {

						if ($scope.employeeList) {
							angular.forEach($scope.employeeList, function (empList) {
								if (result == false && (empList.name == '' || empList.name == undefined)) {

									$scope.employeeInValid = true;
								}
								if (result == true && (empList.name == '' || empList.name == undefined)) {
									$scope.employeeInValid = true;
								}
							});
						}
					});
				}

				//get no of days and reported percapita value on change of end date and disable submit button 
				if (type && type == 'endDate') {
					PolicyService.validateEndDate($scope.policy, $scope.startDateVal, $scope.endDateVal, termEffectiveDateString).then(function (result) {

						if ($scope.employeeList) {
							angular.forEach($scope.employeeList, function (empList) {
								if (result == false && (empList.name == '' || empList.name == undefined)) {

									$scope.employeeInValid = true;
								}
								if (result == true && (empList.name == '' || empList.name == undefined)) {
									$scope.employeeInValid = true;
								}
							});
						}
					});
				}
				$scope.tempList = [];
				$scope.negativeDate = false;
				angular.forEach($scope.employeeList, function (res) {
					if (res.fixedId) {
						if (res.fixedId == $scope.perCapitaClassFixedId) {
							$scope.updateTempList(res, emp);
						}
					} else {
						$scope.updateTempList(res, emp);
					}
				});
				var id = 'endDate' + emp.id + " :input";
				if ($scope.diffDays < 0) {
					angular.element('#' + id).css('border-color', '#b94a48');
					$scope.negativeDate = true;
					$scope.employeeInValid = true;
				} else if ($scope.diffDays == 0) {
					angular.element('#' + id).css('border-color', '#ccc');
				} else {
					angular.element('#' + id).css('border-color', '#ccc');
				}
				$scope.employeeList = $scope.tempList;
			};

			$scope.tot_percapita_amount = 0;
			/**
    * Function to retrieve per capita total on change
    * @params{object} - emp
    * @returns{void} - updates $scope.tot_percapita_amount.
    * @private
    **/
			$scope.getCapitaTotOnChange = function (emp) {
				$scope.tot_percapita_amount = null;

				angular.forEach($scope.employeeList, function (result) {

					if (result.reportedPerCapita !== undefined && result.reportedPerCapita !== '' && result.reportedPerCapita != null || result.reportedPerCapita === 0) {
						if ($scope.tot_percapita_amount == null) {

							$scope.tot_percapita_amount = parseFloat(result.reportedPerCapita);
						} else {
							$scope.tot_percapita_amount = $scope.tot_percapita_amount + parseFloat(result.reportedPerCapita);
						}
					}
				});
			};

			/**
   * Function to remove per Capita row
   * @params{int} - id
   * @returns{void}
   * @private
   **/
			$scope.removeRow = function (id) {
				$scope.invalidStartDate = false;
				$scope.invalidEndDate = false;

				$scope.tempList = [];
				angular.forEach($scope.employeeList, function (res) {
					if (res.id != id) {
						$scope.tempList.push(res);
					}
				});
				$scope.employeeList = $scope.tempList;
				//update total per capita
				$scope.tot_percapita_amount = null;
				angular.forEach($scope.employeeList, function (result) {
					if (result.reportedPerCapita !== undefined && result.reportedPerCapita !== '' && result.reportedPerCapita != null || result.reportedPerCapita === 0) {
						if ($scope.tot_percapita_amount == null) {
							$scope.tot_percapita_amount = parseFloat(result.reportedPerCapita);
						} else {
							$scope.tot_percapita_amount = $scope.tot_percapita_amount + parseFloat(result.reportedPerCapita);
						}
					}
					$scope.validateOnRemove(result, 'startDate');
				});
			};

			/**
   * Function to validate while removing records
   * @params{Object, String} - result, type
   * @returns{void}
   * @private
   **/
			$scope.validateOnRemove = function (result, type) {

				if (result.name == '' || result.name == undefined || result.startDate == null || result.endDate == null || result.totalHours == "") {

					$scope.employeeInValid = true;
				} else {
					$scope.employeeInValid = false;
				}
			};

			/**
   * Function to close screen and go to enter and validate screen
   * @params{void}
   * @returns{void}
   * @private
   **/
			$scope.close = function () {
				if ($scope.employeeList != 0) {
					$scope.$emit('closeFullTimeCapita');
				} else {
					$scope.$emit('closeFullTimeCapitaEmpty');
				}
			};
			/**
   * Function to getDate based on response
   * @params{object} - response
   * @returns {Object} - finalDate
   * @private
   **/
			$scope.getDate = function (res) {
				var dateFinal = new Date(res.year, res.month, res.day);
				return dateFinal;
			};
			//get full time per capita
			if ($scope.sharedClass) {
				var res = $scope.sharedClass.fullTime;

				angular.forEach(res, function (data) {

					var actualDate = new Date(data.startDate);
					var actualEndDate = new Date(data.endDate);
					var start = {
						year: actualDate.getFullYear(),
						month: actualDate.getMonth(),
						day: actualDate.getDate()
					};

					var end = {
						year: actualEndDate.getFullYear(),
						month: actualEndDate.getMonth(),
						day: actualEndDate.getDate()
					};
					$scope.count = $scope.count + 1;
					var rowData = {};
					rowData.fixedId = data.classFixedId;
					rowData.name = data.name;
					rowData.startDate = moment(actualDate).format("MM/DD/YYYY");

					rowData.endDate = moment(actualEndDate).format("MM/DD/YYYY");;
					rowData.id = $scope.count;
					rowData.days = data.days;
					rowData.reportedPerCapita = data.reportedPerCapita;
					if (rowData.name == '' || rowData.name == undefined) {
						$scope.employeeInValid = true;
					} else {
						$scope.employeeInValid = false;
					}
					$scope.employeeList.push(rowData);
					$scope.getCapitaTotal(rowData);
				});
			}

			/**
   * Function to submit per capita
   * @params{void}
   * @returns{event} - to notify containers the event closeFullTimePerCapita
   * @private
   **/
			$scope.onSubmit = function () {
				$scope.finalList = [];
				angular.forEach($scope.employeeList, function (emp) {
					var row = {};
					if (emp.startDate.year && emp.endDate.year) {
						var start = new Date(emp.startDate.year, emp.startDate.month, emp.startDate.day);
						var end = new Date(emp.endDate.year, emp.endDate.month, emp.endDate.day);
						row.startDate = start;
						row.endDate = end;
						row.id = "0913";
						row.name = emp.name;
						row.days = emp.days;
						row.reportedPerCapita = emp.reportedPerCapita;
						//setting up editable boolean values
						row.isReportedEditable = emp.isReportedEditable != null ? emp.isReportedEditable : true;
						row.isNameEditable = emp.isNameEditable != null ? emp.isNameEditable : true;
						row.isStartDateEditable = emp.isStartDateEditable != null ? emp.isStartDateEditable : true;
						row.isEndDateEditable = emp.isEndDateEditable != null ? emp.isEndDateEditable : true;

						$scope.finalList.push(row);
					} else {
						var start = new Date(emp.startDate).toISOString();

						var end = new Date(emp.endDate).toISOString();

						row.startDate = start;
						row.endDate = end;
						row.id = "0913";
						row.name = emp.name;
						row.days = emp.days;
						row.reportedPerCapita = emp.reportedPerCapita;
						//setting up editable boolean values
						row.isReportedEditable = emp.isReportedEditable != null ? emp.isReportedEditable : true;
						row.isNameEditable = emp.isNameEditable != null ? emp.isNameEditable : true;
						row.isStartDateEditable = emp.isStartDateEditable != null ? emp.isStartDateEditable : true;
						row.isEndDateEditable = emp.isEndDateEditable != null ? emp.isEndDateEditable : true;

						$scope.finalList.push(row);
					}
				});
				$scope.sharedClass.fullTime = $scope.finalList;
				$scope.$emit('closeFullTimeCapita');
			};
			/**
   * Function to allow Date format and if not a valid keystroke or dateFormat - either returns false or cancel the event.
   * @params{event, object} - event, field
   * @returns{boolean|event}
   * @private
   **/
			$scope.allowDateFormat = function (event, field) {

				$scope.invalidStartDate = false;
				$scope.invalidEndDate = false;
				setTimeout(function () {

					if (event.target.id == 'startDate') {

						$scope.onSave(field, event.target.id);
					}
					if (event.target.id == 'endDate') {

						$scope.onSave(field, event.target.id);
					}
				});

				if (event.keyCode == 47) {

					return false;
				} else if (event.keyCode < 48 || event.keyCode > 57) {
					event.preventDefault();
				}
			};
			//Restrict Alphabets
			/**
   * Function to restrict user clicks or certain keystrokes that can trigger deletion or edits of records
   * @params{event, object} - event, field
   * @returns{boolean|event} - either returns falls to cancels the event.
   * @private
   **/
			$scope.restrictAlphabets = function (event, field) {

				if (event.keyCode == 46) {
					if (event.value && event.value.indexOf('.') >= 0) {
						if (event.value && event.value.length >= 2) {
							return false;
						}
						return true;
					} else if (event.value && event.value.indexOf('..') >= 0) {
						return false;
					} else {
						return false;
					}
				} else if (event.keyCode < 48 || event.keyCode > 57) {
					event.preventDefault();
				}
			};
		}]
	};
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/FullPerCapitaDirective_MSF/FullPerCapita.js
// module id = 1741
// module chunks = 0